// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button__add-score-description-wrpper[data-v-db88624e]{max-width:910px;margin:auto}", ""]);
// Exports
module.exports = exports;
